import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Twilio-compliant SMS consent checkbox.
 * - Required to be true before form can be submitted.
 * - Discloses program, frequency, cost, opt-out, and links to Privacy + Terms.
 */
export const SmsConsent = ({ checked, onChange, testid = 'sms-consent-checkbox' }) => {
  return (
    <label
      data-testid={`${testid}-label`}
      className="flex items-start gap-3 p-4 rounded-lg bg-[#050814] border border-[#B8860B]/30 cursor-pointer hover:border-[#B8860B]/60 transition-colors"
    >
      <input
        type="checkbox"
        data-testid={testid}
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        required
        className="mt-1 accent-[#B8860B] h-4 w-4 flex-shrink-0"
      />
      <span className="text-xs text-[#F4F1EA]/85 leading-relaxed">
        <strong className="text-[#B8860B]">I agree to receive text messages</strong> from Creek
        Bottom Ranch &amp; Resort about my reservation, including confirmations, reminders, and
        important updates, sent via Twilio. Message frequency varies. Message and data rates may
        apply. Reply <strong>STOP</strong> to unsubscribe or <strong>HELP</strong> for help. Phone
        numbers and SMS opt-in data are never shared with third parties for marketing. See our{' '}
        <Link to="/privacy" target="_blank" className="text-[#B8860B] hover:underline">
          Privacy Policy
        </Link>{' '}
        and{' '}
        <Link to="/terms" target="_blank" className="text-[#B8860B] hover:underline">
          Terms &amp; Conditions
        </Link>
        .
      </span>
    </label>
  );
};

export default SmsConsent;
